import Model from "./base/model";

class SimulationOrders extends Model {
  resourceName() {
    return "simulation_orders";
  }

  fields() {
    return {
      order_id: "",
      simulation: "",
      return_simulation: "",
      deadline: "",
      rate_value: "",
      shipping_value: "",
      weight_shipping_value: "",
      rates: "",
      alter_rates: "",
      ciltronic: "",
      config_rates: "",
      order: { jsonApi: "hasOne", type: "orders"},
      simulation_orders_addresses: { jsonApi: "hasMany", type: "simulation_orders_addresses"},
      rates_additional: ""
    };
  }

  async updateRates(id, data) {
    return this.request(
      this.resourceName() + `/rates/${id}`,
      "PATCH",
      {},
      data
    );
  }

}

export default new SimulationOrders();
